// extracted by mini-css-extract-plugin
export default {"tab":"index_tab_EijwO clearfix"};